import { useMediaQuery } from 'react-responsive';

const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ maxWidth: 992 });
  return isNotMobile ? children : null;
};

export default Default;
